import { push as pushLocation } from "react-router-redux";
import { secureFrontToBack } from "./dataConversion";
import { fieldErrorsBackToFront } from "./../misc/dataConversion";
import ContactRepository from "./ContactRepository";
import { AUTH_ACTIONS } from "../auth/authActions";
/* --- Action names --- */
export const CONTACT_ACTIONS = {
    CONTACT_STARTED: "contact-started",
    CONTACT_FAILED: "contact-failed",
    CONTACT_SUCCEEDED_FALSE: "contact-succeeded-false",
    CONTACT_SUCCEEDED_TRUE: "contact-succeeded-true",
    DATA_LOAD_STARTED: "contact-data-load-started",
    DATA_LOAD_SUCCEEDED: "contact-data-load-succeeded",
    DATA_LOAD_FAILED: "contact-data-load-failed"
};
export const loadData = () => async (dispatch, getState) => {
    const state = getState();
    if (state.contact.contactData != null) {
        return;
    }
    dispatch({ type: CONTACT_ACTIONS.DATA_LOAD_STARTED });
    try {
        const response = await ContactRepository.getContactData();
        if (response.success) {
            dispatch({
                type: CONTACT_ACTIONS.DATA_LOAD_SUCCEEDED,
                payload: response.data
            });
            return;
        }
    }
    catch (error) {
        console.error(error);
    }
    dispatch({ type: CONTACT_ACTIONS.DATA_LOAD_FAILED });
};
/**
 * Dispatches series of actions while sending public contact info to API
 *
 * @method contactPublic
 * @param {Object} info Contact form value
 * @returns {Function} Redux thunk
 */
export const contactPublic = (info) => async (dispatch) => {
    dispatch({ type: CONTACT_ACTIONS.CONTACT_STARTED });
    let response;
    try {
        response = await ContactRepository.submitPublicContact(info);
    }
    catch (error) {
        return dispatch({ type: CONTACT_ACTIONS.CONTACT_FAILED, payload: error });
    }
    if (!response.success) {
        const preparedErrors = fieldErrorsBackToFront(response.errors);
        dispatch({ type: CONTACT_ACTIONS.CONTACT_SUCCEEDED_FALSE, payload: preparedErrors });
    }
    else {
        dispatch({
            type: CONTACT_ACTIONS.CONTACT_SUCCEEDED_TRUE
        });
        dispatch(pushLocation("/public/thankYou"));
    }
};
/**
 * Dispatches series of actions while sending secured contact info to API
 *
 * @method contactSecure
 * @param {Object} info Contact form value
 * @returns {Function} Redux thunk
 */
export const contactSecure = (info) => async (dispatch) => {
    dispatch({ type: CONTACT_ACTIONS.CONTACT_STARTED });
    const mappedInfo = secureFrontToBack(info);
    let response;
    try {
        response = await ContactRepository.submitSecureContact(mappedInfo);
    }
    catch (error) {
        dispatch({ type: CONTACT_ACTIONS.CONTACT_FAILED, payload: error });
        if (error.response.status === 401) {
            dispatch({ type: AUTH_ACTIONS.LOGOUT, payload: false });
            dispatch(pushLocation("/public"));
        }
        return;
    }
    if (!response.success) {
        const preparedErrors = fieldErrorsBackToFront(response.errors);
        dispatch({ type: CONTACT_ACTIONS.CONTACT_SUCCEEDED_FALSE, payload: preparedErrors });
    }
    else {
        dispatch({
            type: CONTACT_ACTIONS.CONTACT_SUCCEEDED_TRUE
        });
        dispatch(pushLocation("/secured"));
    }
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/contact/contactActions.ts